(() => {
  if (window.twoWsBikeOrderConsent) return;
  const panels = () => [...document.querySelectorAll('bike-order-consent')];
  const signature = cart => cart.items.map(item => `${item.key}:${item.quantity}:${item.final_line_price};`).join('') + `|${cart.total_price}`;
  const panelFor = target => {
    const formId = target?.getAttribute?.('form') || target?.form?.id || target?.id;
    return panels().find(panel => panel.dataset.form === formId);
  };
  const checkbox = panel => panel?.querySelector('input[type="checkbox"]');
  const showError = panel => {
    panel.querySelector('[role="alert"]').hidden = false;
    checkbox(panel).focus();
  };
  window.twoWsBikeOrderConsent = {
    accepted(target) {
      const panel = panelFor(target);
      return !panel || checkbox(panel).checked;
    },
    block(event) {
      const target = event.type === 'submit' ? event.submitter || event.target : event.target?.closest?.('#checkout, #CartDrawer-Checkout');
      if (!target) return false;
      const panel = panelFor(target);
      if (!panel || checkbox(panel).checked) return false;
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(panel);
      return true;
    },
    attributes(cart, target) {
      const panel = panelFor(target);
      if (!panel) return {};
      if (!checkbox(panel).checked || panel.dataset.cartSignature !== signature(cart)) throw new Error('Je winkelwagen is gewijzigd. Controleer de uitleg en vink het akkoord opnieuw aan.');
      const result = {};
      panel.querySelectorAll('input[name^="attributes["]').forEach(input => {
        if (input.disabled || (input.type === 'checkbox' && !input.checked)) return;
        const key = input.name.slice(11, -1);
        result[key] = input.value.replace(/\s+/g, ' ').trim();
      });
      return result;
    },
  };
  class BikeOrderConsent extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const input = checkbox(this);
      input.checked = false;
      const sync = () => {
        this.querySelectorAll('[data-bike-consent-field]').forEach(field => { field.disabled = !input.checked; });
        this.querySelector('[data-bike-consent-time]').value = input.checked ? new Date().toISOString() : '';
        if (input.checked) this.querySelector('[role="alert"]').hidden = true;
      };
      input.addEventListener('change', sync);
      sync();
    }
  }
  customElements.define('bike-order-consent', BikeOrderConsent);
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    panels().forEach(panel => {
      const input = checkbox(panel);
      input.checked = false;
      input.dispatchEvent(new Event('change', {bubbles:true}));
    });
  });
})();
